module.exports = __webpack_public_path__ + "static/media/mia_spanish_maxican.0d99e848.mp3";